import ArticleRejectReason from "./components/articleRejectReason";

export default ArticleRejectReason;